export default __webpack_public_path__ + "static/file_example_MP4_480_1_5MG-5f55925d87b05fff5ee12d7b00238c60.mp4";